import script from "./addOrEditServerModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./addOrEditServerModal.vue?vue&type=script&lang=ts&setup=true"

import "./addOrEditServerModal.vue?vue&type=style&index=0&id=21b58f36&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21b58f36"]])

export default __exports__